<template>
  <div>
    <!-- 图片上传 -->
    <img-uploader
      :min="config.baseQuestionLimitMin || undefined"
      :max="config.baseQuestionLimitMax || undefined"
      ref="imageUploader"
      :tips="computedTips"
      v-if="editable"
    />
    <!-- 图片展示 -->
    <template v-else>
      <template v-if="computedValue && computedValue.length">
        <el-image
          v-for="(url, index) in computedValue"
          :key="index"
          style="width: 100px; height: 100px; margin-right: 10px"
          :src="url"
          :preview-src-list="computedValue"
          fit="contain"
        >
        </el-image>
      </template>
      <span v-else>-</span>
    </template>
  </div>
</template>

<script>
import { getCompMix } from "../../mixins/comp-mix";
import ImgUploader from "@/components/img-uploader/index.vue";
export default {
  mixins: [getCompMix(true)],
  components: {
    ImgUploader,
  },
  computed: {
    computedTips() {
      const tipsArr = ["图片格式支持jpg、jpeg、png，大小不超过10M"];
      if (this.config.baseQuestionLimitMin) {
        tipsArr.push(`至少上传${this.config.baseQuestionLimitMin}张图片`);
      }
      if (this.config.baseQuestionLimitMax) {
        tipsArr.push(`最多上传${this.config.baseQuestionLimitMax}张图片`);
      }
      tipsArr.push("上传后可点击放大查看");
      return tipsArr;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化或回填数据
    init() {
      if (this.editable) {
        this.$refs.imageUploader.init({
          imgs: this.computedValue,
        });
      }
    },
    // 提供方法给外部，用于获取上传成功的照片地址
    getData() {
      const imgData = this.$refs.imageUploader.getData();
      console.log("imgData---", imgData);
      return imgData;
    },
  },
};
</script>

<style lang="scss" scoped></style>
